import React from 'react';
import { autobind } from 'core-decorators';
import BasePage from 'components/BasePage';
import styledComp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import dataStorage from 'misc/data-storage';
import logo from 'images/logo.png';
import background1 from 'images-desktop/login/background1.png';
import background2 from 'images-desktop/login/background2.png';
import background3 from 'images-desktop/login/background3.png';
import background4 from 'images-desktop/login/background4.png';
import LoginForm from './components/LoginForm';
import LoginFooter from './components/LoginFooter';

const propTypes = {
};

@autobind
class LoginPage extends BasePage {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // Save where does the user come from.
    this.from = this.parseQueryParam('from', this.props.location);

    // When we are in the login page, clear previous credential.
    dataStorage.clearCredential();
  }

  getTitle() {
    return 'Login';
  }

  getRandomBackground() {
    switch (Math.floor(Math.random() * 4) + 1) {
      case 1: return background1;
      case 2: return background2;
      case 3: return background3;
      case 4: return background4;
      default: return background1;
    }
  }

  renderContent() {
    return (
      <FlexColContainer
        width="match_parent"
        height="wrap_content"
        justifyContent="space-between"
        alignItems="center"
        background={`url(${this.getRandomBackground()}) no-repeat center`}
        backgroundSize="cover"
      >
        <FlexColContainer
          width="300px"
          height="wrap_content"
          margin="128px 0 0 0"
          alignItems="center"
        >
          <styledComp.Img
            width="200px"
            height="wrap_content"
            margin="0 0 24px 0"
            src={logo}
            alt="Logo"
          />

          <FlexRowContainer
            width="match_parent"
            height="wrap_content"
            margin="0 0 24px 0"
            justifyContent="space-between"
            alignItems="center"
          >
            <styledComp.Div
              width="50px"
              height="1px"
              backgroundColor="#ffffff"
            />

            <styledComp.Span
              width="wrap_content"
              height="wrap_content"
              color="textPrimaryLight"
              fontSize="18px"
            >
              Login to Your Account
            </styledComp.Span>

            <styledComp.Div
              width="50px"
              height="1px"
              backgroundColor="#ffffff"
            />
          </FlexRowContainer>

          <LoginForm
            width="240px"
            height="wrap_content"
          />
        </FlexColContainer>

        <LoginFooter
          width="wrap_content"
          height="wrap_content"
          margin="16px 0"
        />
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
LoginPage.propTypes = propTypes;

export default LoginPage;
